import { render, staticRenderFns } from "./registerStep4.vue?vue&type=template&id=0df64bf0&scoped=true"
import script from "./registerStep4.vue?vue&type=script&lang=js"
export * from "./registerStep4.vue?vue&type=script&lang=js"
import style0 from "./registerStep4.vue?vue&type=style&index=0&id=0df64bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df64bf0",
  null
  
)

export default component.exports